import Face from './Face';

export default Face;
